module.exports = __webpack_public_path__ + "img/cv.cvc4df14e.svg";